export const CHARACTER_PER_PAGE_MAX = 10;
